import once from 'lodash/once'
import { LoadCSS, loadScript } from '~/utils/script'
import ruLang from '~/assets/redactorx/i18n.js'

export const loadEditorAssets = once(() => {
  if (process.client) {
    LoadCSS('/redactorx/redactorx.min.css')
    loadScript({
      url: '/redactorx/redactorx.min.js'
    }).then(() => {
      window.RedactorX.lang['ru'] = ruLang
    })
  }
})
